import { PrimarySmallButton } from 'components/ReusableComponents/Button/SmallButtons'
import AvailabilityDialog from 'features/Messaging/GuestInfoSidebar/AvailabilitySearchForm/AvailabilityDialog/index'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useToasts } from 'react-toast-notifications'
import subscribersApi from 'services/api/subscribers'

import styles from './AvailabilitySearchForm.module.scss'

const AvailabilitySearchForm = ({ chatId, subscriberId }) => {
  const { addToast } = useToasts()

  const { parentChainCode } = useSelector(s => s.hotelDetails)

  const [lastShortlink, setLastShortlink] = useState()

  useEffect(() => {
    subscribersApi
      .getLastShortLink({ subscriberId })
      .then(lastShortlink => {
        setLastShortlink(lastShortlink)
      })
      .catch(() => {
        addToast(`Couldn't get last short link`, {
          appearance: 'error',
          autoDismiss: true
        })
      })
  }, [subscriberId, addToast])

  const [isAvailabilityInfoVisible, setIsAvailabilityInfoVisible] = useState()

  if (!parentChainCode) {
    return null
  }

  return (
    <div className={styles.availabilityControlsHolder}>
      <PrimarySmallButton
        onClick={() => setIsAvailabilityInfoVisible(true)}
        disabled={!lastShortlink}
      >
        Open availability tool
      </PrimarySmallButton>
      {isAvailabilityInfoVisible && (
        <AvailabilityDialog
          onClose={() => setIsAvailabilityInfoVisible(false)}
          subscriberId={subscriberId}
          chatId={chatId}
          lastShortlink={lastShortlink}
        />
      )}
    </div>
  )
}

export default AvailabilitySearchForm
